import { Spinner, SpinnerSize } from "@fluentui/react";
import { useEffect, useRef } from "react";
import { OrderModel } from "../../../orders/models/OrderModel";
import OrderDetailView from "../../../orders/views/users/OrderDetailView";
import { ShortInvoiceModel } from "../../models/InvoiceModel";
import { useInvoiceVM } from "../../viewmodels/InvoiceVM";
import InvoiceDetailView from "../shared/InvoiceDetailView";
import InvoiceGridView from "./InvoiceGridView";

export default function InvoiceView() {
    const hasLoaded = useRef(false);
    const vm = useInvoiceVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList();
    }, [vm]);

    const onCompletedDetail = () => {
        //if (window.confirm("Would you like to refresh the data?")) {
        //    vm.getList();
        //}

        vm.setShowDetail(false);
    }

    const headerView = () => {
        return <div className="left pv-10 ph-15 font-title">
            Invoices
        </div>;
    }

    const mainContent = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row center">
                {headerView()}
            </div>

            <div>
                {vm.loading && <Spinner size={SpinnerSize.large} />}

                <InvoiceGridView
                    invoices={vm.invoices}
                    key={vm.listHash}
                    onDetail={(invoice: ShortInvoiceModel) => {
                        vm.setShowDetail(true);
                        vm.setInvoice(invoice);
                    }}
                />
            </div>
        </div>;
    }

    const onOrderDetail = (order: OrderModel) => {
        vm.setSelectedOrder(order);
        vm.setShowOrderDetail(true);
    }

    const onCloseOrderDetail = () => {
        vm.setSelectedOrder(null);
        vm.setShowOrderDetail(false);
    }

    return <>
        {mainContent()}

        {vm.showDetail && vm.invoice !== null && <>
            <InvoiceDetailView
                id={vm.invoice.id}
                onClose={onCompletedDetail}
                onOrderDetail={onOrderDetail}
            />
        </>}

        {vm.showOrderDetail && vm.selectedOrder !== null && <>
            <OrderDetailView
                order={vm.selectedOrder}
                onClose={onCloseOrderDetail}
                onDelete={() => { }}
                onPlaceOrder={() => { }}
                onInvoiceDetail={() => { }}
            />
        </>}
    </>;
}